
<template>
  <div class="modal-container">
    <!--UPLOAD-->
    <div v-if="isUpdating" class="fa-3x text-center">
      <i class="fas fa-spinner fa-spin"></i>
    </div>
    <h1>File Upload</h1>
     <span class="edit-add" v-if="this.batch_id != null"><router-link :to="`/batches/ultralocal.ul_file_uploads?bfed_batch_id=`+this.batch_id"><i>Click here to return to the batch summary page</i></router-link></span>
     <br>
     <span v-if="this.uploadType === 'PREFED to BFED'" class="edit-add"><router-link :to="`/tables/ultralocal.ul_named_bfed_batches`"><i>Click here to view all batches</i></router-link></span>
     <span v-if="this.uploadType === 'Candidate Endorsements Staging'" class="edit-add"><router-link :to="`/tables/ultralocal.ul_candidate_matching_uploads?%7B%22where%22%3A%7B%22logicalOperator%22%3A%22all%22%2C%22children%22%3A%5B%7B%22type%22%3A%22query-builder-rule%22%2C%22query%22%3A%7B%22rule%22%3A%22upload_type%22%2C%22selectedOperator%22%3A%22equal%22%2C%22selectedOperand%22%3A%22Upload%20Type%22%2C%22value%22%3A%22Candidate%20Endorsements%20Staging%22%7D%7D%5D%7D%2C%22table%22%3A%22ultralocal.ul_file_uploads%22%2C%22limit%22%3A25%2C%22offset%22%3A1%2C%22orderBy%22%3Anull%2C%22workflow%22%3Anull%7D`"><i>Click here to view all candidate endorsements staging uploads</i></router-link></span>
     <span v-if="this.uploadType === 'Race Ratings'" class="edit-add"><router-link :to="`/tables/ultralocal.ul_candidate_matching_uploads?%7B%22where%22%3A%7B%22logicalOperator%22%3A%22all%22%2C%22children%22%3A%5B%7B%22type%22%3A%22query-builder-rule%22%2C%22query%22%3A%7B%22rule%22%3A%22upload_type%22%2C%22selectedOperator%22%3A%22equal%22%2C%22selectedOperand%22%3A%22Upload%20Type%22%2C%22value%22%3A%22Race%20Ratings%22%7D%7D%5D%7D%2C%22table%22%3A%22ultralocal.ul_file_uploads%22%2C%22limit%22%3A25%2C%22offset%22%3A1%2C%22orderBy%22%3Anull%2C%22workflow%22%3Anull%7D`"><i>Click here to view all race ratings uploads</i></router-link></span>
     
        <br />
        <br/>
    <div v-if="isInitial || isSaving">
      <span class="fileUpload" > 
        <div class="row">
              <div class="col-sm-12">
                <div class="form-group">
       
        <div class="custom-select" style="width: 250px">
          <label for="upload-select">Please select upload type.</label>
          <select class="form-control" id="upload_select" v-model="selected" @change="handleChange" ref="upload_select">
             <option value="ultralocal_ul_bfed">PREFED to BFED</option>
             <option value="candidate_endorsements_staging">Candidate Endorsements Staging</option>
             <option value="race_ratings">Race Ratings</option>
          </select>
        </div>
                </div>
              </div>
        </div>
      </span>
    </div>
    <br />
    <div class="modal-body">
      <div v-if="(isInitial || isSaving) && this.uploadType === 'PREFED to BFED'" class='meta-table'>
      <div v-if="!this.batch_id"><b><i>Please enter the election date id and your name before uploading your file.</i></b></div>
      <div v-else><b><i>The election date id can't be added or changed on an existing batch. Please enter your name before uploading your file.</i></b></div>
      <br/>
      <div class='meta-table'>
      <div class='meta-cell'><input v-model="election_date_id" type="text"  @input="validateNumber"   :disabled="this.batch_id > 0" class="form-control" placeholder="Election date id"></div>
      <div class='meta-cell'><input v-model="user" type="text" class="form-control" placeholder="Uploaded by"></div>
      <div class='meta-cell'><input v-model="batch_name" type="text" class="form-control" placeholder='Batch Name' v-if="this.batch_id == null"></div>
      <div class='meta-cell'><input v-model="batch_start_date" type="text" placeholder='Start Date (yyyy-mm-dd)' class="form-control" v-if="this.batch_id == null"></div>
      </div>
      <p v-if="error_message" style="color: red; margin-top: 4px;">
        {{ error_message }}
    </p>
    </div>
    <br/>
    <form
      enctype="multipart/form-data"
      novalidate
      v-if="(isInitial || isSaving) && this.uploadType"
    >
      <div class="dropbox">
        <input
          v-if="this.uploadType == 'PREFED to BFED' || this.uploadType == 'Candidate Endorsements Staging' || this.uploadType === 'Race Ratings'"
          type="file"
          :disabled="isSaving"
          @change="
            filesChange($event.target.name, $event.target.files);
            fileCount = $event.target.files.length;
          "
          accept=".csv"
          class="input-file"
        />
        <input
          v-if="this.uploadType == 'Source Document'"
          type="file"
          :disabled="isSaving"
          @change="
            filesChange($event.target.name, $event.target.files);
            fileCount = $event.target.files.length;
          "
          accept=".pdf,.csv"
          class="input-file"
        />
        <p v-if="isInitial">
          Drag your file here to begin<br />
          or click to browse
        </p>
        <p v-if="isSaving">Uploading ...</p>
      </div>
    </form>
    </div>
    <div>
      <p></p>
      <p v-if="isSuccess">This is the success screen</p>

      <p>
        <button
          v-if="isFinished"
          class="btn btn-default submit-btn uploadsubmit"
          @click="reset"
        >
          Reset
        </button>
      </p>
    </div>
  </div>
</template>

<script>
const STATUS_INITIAL = 0,
  STATUS_SAVING = 1,
  STATUS_SUCCESS = 2,
  STATUS_UPDATING = 3,
  STATUS_FINISHED = 4,
  STATUS_FAILED = 5;

export default {
  name: "GenericFileUpload",
  data() {
    return {
      uploadedFiles: null,
      fileUpdloadType: null,
      uploadError: null,
      currentStatus: null,
      election_date_id: null,
      batch_start_date: null,
      error_message: null,
      user: null,
      uploadType: null,
      user_id: null,
      batch_id: null,
      batch_name: null
    };
  },
  computed: {
    isInitial() {
      return this.currentStatus === STATUS_INITIAL;
    },
    isSaving() {
      return this.currentStatus === STATUS_SAVING;
    },
    isSuccess() {
      //this.$router.push('/tables/ultralocal.ul_file_uploads')
      return this.currentStatus === STATUS_SUCCESS;
    },
    isFailed() {
      //this.$router.push('/tables/ultralocal.ul_file_uploads')
      return this.currentStatus === STATUS_FAILED;
    },
    isFinished() {
      //this.$router.push('/tables/ultralocal.ul_file_uploads')
      this.currentStatus === STATUS_FINISHED;
    },
    isUpdating() {
      return this.currentStatus === STATUS_UPDATING;
    },
  },
  methods: {
    reset() {
       
      // reset form to initial state
      this.currentStatus = STATUS_INITIAL;
      this.uploadedFile = null;
      this.uploadError = null;
      this.election_date_id = null;
      this.batch_id = null;
      this.user= null;
      this.batch_name = null;
      this.batch_start_date = null;
          
    },
    validateNumber(event) {
      // Replace any character that is not a number
        const regex = /[^0-9]/g;
        this.election_date_id = this.election_date_id.replace(regex, '');
      
    },
    isValidYYYYMMDD(str) {
      
      if (!str) {
         return true;
      }
      if (!/^\d{4}-\d{2}-\d{2}$/.test(str)) {
          return false;
      }
      const date = new Date(str);
      if (isNaN(date.getTime())) {
          return false;
      }
      
      return true;
   },

    async save(formData) {
      this.error_message = null;
      if (!this.isValidYYYYMMDD(this.batch_start_date)){
          this.error_message = 'The start date is invalid.  Please enter a valid date in YYYY-MM-DD format.'
          this.currentStatus = STATUS_INITIAL;
          return;
      }
      this.currentStatus = STATUS_SAVING;
      if (this.uploadType == "PREFED to BFED") {
        await this.savePREFEDtoBFED(formData);
      }
      if (this.uploadType == "Candidate Endorsements Staging") {
        await this.saveGenericFiles(formData, "Candidate Endorsements Staging", "candidate_endorsements_staging");
      }
       if (this.uploadType == "Race Ratings") {
        await this.saveGenericFiles(formData, "Race Ratings", "race_ratings");
      }
        this.reset();
    
    },
    async savePREFEDtoBFED(formData) {
      
      if (! this.batch_id){
           this.batch_id = await this.createNamedBfedBatch();
                      
           if (this.batch_id['success'] === false){
             alert(`There was an error in uploading the file. ${this.batch_id['message']}`);
             //this.uploadError = response2.statusText;
             this.currentStatus = STATUS_FAILED;
             this.batch_id = null;
             return;
           }
           this.batch_id = this.batch_id['data']['id'];
                               
      }
      let upload_url = "https://bp-import-engine-artifacts.s3.amazonaws.com/";
      let bucket_name = "bp-import-engine-artifacts";
      let key  ;
      if (process.env.VUE_APP_API4_DOMAIN === "http://localhost:3000" || process.env.VUE_APP_API4_DOMAIN == "https://dev-api4.ballotpedia.org") {
          key = `prefed_to_bfed/bfed_files/test_yes/user_${this.user_id}/named_bfed_batch_${this.batch_id}/`
      
      }else{
          key = `prefed_to_bfed/bfed_files/test_no/user_${this.user_id}/named_bfed_batch_${this.batch_id}/`
      }

       // first we make sure the file name is unique
      let file = formData.values().next().value;
      let fileName = file.name;
      key = key + fileName;
      let isUnique = await this.checkUniqueFile(fileName);
      if (!isUnique) {
        alert("A file with that name has already been uploaded.");
        this.currentStatus = STATUS_FAILED;
        return;
      }
            
      let presigned_url = await this.getPresignedUrl(file, bucket_name, key);
      
      let upload_result = await this.uploadToS3(presigned_url, file,upload_url);
      
      if (!upload_result.ok) {
        alert(upload_result.statusText);
        this.uploadError = upload_result.statusText;
        this.currentStatus = STATUS_FAILED;
        return;
      }
       
      // now let's update the ultralocal.ul_file_uploads table
      let user_name = null;
      if (this.user){
        user_name = this.user.replace(/\s+/g, '_')
      }
      let table_update = await this.updateUlFileUploads(
        fileName,
        "PREFED to BFED",
        "upload to s3 succeeded",
        this.batch_id,
        user_name
      );
       
      this.reset();
      if (!table_update.success) {
        alert('There was an error in processing the file.  It was not added to the ultralocal.ul_file_uploads table');
        //this.uploadError = response2.statusText;
        this.currentStatus = STATUS_FAILED;
        return;
      }else{
        this.batch_id = null;   //set batch_id to null so that it is not persisted for other file uploads unless it is specifically sent in on the url.
        alert('Your file is being processed. Check the ultralocal.ul_file_uploads edit page for status.');
        this.currentStatus = STATUS_FINISHED
        return;
      }
      
    },
     async saveGenericFiles(formData, uploadType, key) {
      let upload_url = "https://ballotpedia-file-uploads.s3.amazonaws.com/";
      let bucket_name = "ballotpedia-file-uploads";
      
      key = `candidate_matching_import/schema_name/public/table_name/${key}/`;
       if (process.env.VUE_APP_API4_DOMAIN === "http://localhost:3000" || process.env.VUE_APP_API4_DOMAIN == "https://dev-api4.ballotpedia.org") {
         key = `${key}test/`; 
       } else {
         key = `${key}prod/`;
       }

       // first we make sure the file name is unique
      let file = formData.values().next().value;
      let fileName = file.name;
      key = key + fileName;
      let isUnique = await this.checkUniqueFile(fileName);
      // console.log('isUnique', isUnique);
      if (!isUnique) {
        alert("A file with that name has already been uploaded.");
        this.currentStatus = STATUS_FAILED;
        return;
      }
            
      let presigned_url = await this.getPresignedUrl(file, bucket_name, key);
      // console.log('presigned_url', presigned_url);
      let upload_result = await this.uploadToS3(presigned_url, file,upload_url);
      // console.log('upload_result', upload_result);
      if (!upload_result.ok) {
        alert(upload_result.statusText);
        this.uploadError = upload_result.statusText;
        this.currentStatus = STATUS_FAILED;
        return;
      }
       
      // now let's update the ultralocal.ul_file_uploads table
      let user_name = null;
      if (this.user){
        user_name = this.user.replace(/\s+/g, '_')
      }
      let table_update = await this.updateUlFileUploads(
        fileName,
        uploadType,
        "upload to s3 succeeded",
        null,
        user_name
      );
       
      this.reset();
      if (!table_update.success) {
        alert('There was an error in processing the file.  It was not added to the ultralocal.ul_file_uploads table');
        //this.uploadError = response2.statusText;
        this.currentStatus = STATUS_FAILED;
        return;
      }else{
        alert('Your file is being processed. Check the ultralocal.ul_file_uploads edit page for status.');
        this.currentStatus = STATUS_FINISHED
        return;
      }
      
    },
    async uploadToS3(presigned_url, file, upload_url) {
      // console.log('presigned_url', presigned_url);
      // console.log('file', file);
      // console.log('upload_url', upload_url);
      let formdata = new FormData();

      for (var key in presigned_url.data) {
        formdata.append(key, "" + presigned_url.data[key]);
         
      }
      formdata.append("file", file);
      
      let response2 = await fetch(`${upload_url}`, {
        method: "POST",
        headers: { ACL: "public-read" },
        body: formdata,
      });

      
      return response2;
    },
    async createNamedBfedBatch() {
      const now = new Date();
      const timestamp = now.toISOString().replace(/[-T:.Z]/g, ''); // ISO string without special characters

      //OLD:  Combine the timestamp and random string to form a batch name
      //`BATCH-${timestamp}-automatically created based on a file uploaded by - ${this.user_name}`;
      //take submitted value for new batch name OR if empty do the old way
      let batchName = this.batch_name ? this.batch_name : `BATCH-${timestamp}-automatically created based on a file uploaded by - ${this.user_name}`;
      let dataObject = {};
      dataObject["name"] = batchName;
      dataObject["source_type"] = 2;
      dataObject["userid"] = parseInt(this.user_id);
      dataObject["election"] = parseInt(this.election_date_id);
      dataObject["state"] = null;
      dataObject["batch_start_date"] = this.batch_start_date
      let payload = {
        data: [dataObject],
        table: "ultralocal.ul_named_bfed_batches",
      };
      let headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
      };
      headers.resource = `${process.env.VUE_APP_API4_DOMAIN}/crud/insertOne`;

      let response = await fetch(
        `${process.env.VUE_APP_API4_DOMAIN}/users/authorize`,
        {
          method: "POST",
          headers: headers,
          credentials: "include",
          body: JSON.stringify(payload),
        }
      );
      response = await response.json();
      return response;

    },
    async updateUlFileUploads(fileName, uploadType, uploadStatus,named_bfed_batch,user,uploadLink = null) {
      let dataObject = {};
      dataObject["file_name"] = fileName;
      dataObject["upload_type"] = uploadType;
      dataObject["upload_status"] = uploadStatus;
      dataObject["upload_results_s3_link"] = uploadLink;
      dataObject["named_bfed_batch"] = parseInt(named_bfed_batch);
      dataObject['uploaded_by'] = user;
      let payload = {
        data: [dataObject],
        table: "ultralocal.ul_file_uploads",
      };
      console.log('payload to upload athe table', payload);
      let headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
      };
      headers.resource = `${process.env.VUE_APP_API4_DOMAIN}/crud/insertOne`;

      let response = await fetch(
        `${process.env.VUE_APP_API4_DOMAIN}/users/authorize`,
        {
          method: "POST",
          headers: headers,
          credentials: "include",
          body: JSON.stringify(payload),
        }
      );
      response = await response.json();
      console.log('updateUlFileUploads response', response);
      return response;
    },
    async getUserId() {
      let headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
      };
      headers.resource = `${process.env.VUE_APP_API4_DOMAIN}/users/get_user_id_by_api_key`;

      let response = await fetch(
        `${process.env.VUE_APP_API4_DOMAIN}/users/authorize`,
        {
          method: "GET",
          headers: headers,
          credentials: "include"
        }
      );
      response = await response.json()
      return response;
    },
    async getPresignedUrl(file, bucket_name, key) {
      let headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
      };
      headers.resource = `${process.env.VUE_APP_API4_DOMAIN}/files/get_presigned_url_post`;

      let response1 = await fetch(
        `${process.env.VUE_APP_API4_DOMAIN}/users/authorize`,
        {
          method: "POST",
          headers: headers,
          credentials: "include",
          body: JSON.stringify({
            filename: key,
            mimetype: file.type,
            bucket_name: bucket_name,
          }),
        }
      );
      response1 = await response1.json(); // Convert response to JSON
      if (!response1.data || !response1.success) {
        alert(response1.message);
        this.uploadError = response1.message;
        this.currentStatus = STATUS_FAILED;
        return;
      } else {
        return response1;
      }
    },

    async checkUniqueFile(fileName) {
      let query = `{"where":{"logicalOperator":"all","children":[{"type":"query-builder-rule","query":{"rule":"file_name","selectedOperator":"equal","selectedOperand":"File Name","value":"${fileName}"}}]},"table":"ultralocal.ul_file_uploads","limit":25,"offset":1,"orderBy":null,"isCountOnly":false}`;
       
      let headers = {
        "Content-Type": "application/json",
        Accept: "application/json",
      };
      headers.resource = `${process.env.VUE_APP_API4_DOMAIN}/crud/filteredData`;

      let response1 = await fetch(
        `${process.env.VUE_APP_API4_DOMAIN}/users/authorize`,
        {
          method: "POST",
          headers: headers,
          credentials: "include",
          body: query,
        }
      );
      response1 = await response1.json(); // Convert response to JSON
      if (response1["data"].length === 0) {
        return true;
      } else {
        return false;
      }
    },
    filesChange(fieldName, fileList) {
       
      // handle file changes
      const formData = new FormData();
       
      if (!fileList.length) return;
      // append the files to FormData
      Array.from(Array(fileList.length).keys()).map((x) => {
        formData.append(
          fieldName,
          fileList[x],
          fileList[x].name.replace(/ /g, "_")
        );
      });
      // save it
      this.save(formData);
    },

    closeEditorModal() {
      var elem = document.querySelector("#file_editor_container");
      elem.style.display = "none";
      this.state = null;
      this.user = null; // Clear the state, user, and year
      this.year = null;
      this.reset();
    },
    handleChange(e) {
      if (e.target.options.selectedIndex > -1) {
        this.uploadType =
          e.target.options[e.target.options.selectedIndex].innerHTML;
         
      }
    },
  },

  async mounted() {
   this.selected = "";
   this.reset();

   //this.selected = "ultralocal_ul_bfed";
   //this.$el.querySelectorAll('select').trigger('change');
   const electionIdFromUrl = this.$route.query.election_id;
    if (electionIdFromUrl) {
      this.election_date_id = electionIdFromUrl;
    }
   let user_info = await this.getUserId();
  
   this.user_id = user_info['data']['user']['id'];
   this.user_name = `${user_info['data']['user']['first_name']} ${user_info['data']['user']['last_name']}`
   if (window.location.href.indexOf("bfed_batch") > -1) {
       this.batch_id = this.$route.query.bfed_batch_id 
    } else {
      this.batch_id = null
  
    }
       
  }
};
</script>

<style scoped>
.dropbox {
  outline: 2px dashed grey; /* the dash box */
  outline-offset: -10px;
  background: lightcyan;
  color: dimgray;
  padding: 10px 10px;
  min-height: 200px; /* minimum height */
  position: relative;
  cursor: pointer;
  border-radius: 5px;
}
.input-file {
  opacity: 0; /* invisible but it's there! */
  width: 100%;
  height: 200px;
  position: absolute;
  cursor: pointer;
}
.dropbox:hover {
  background: lightblue; /* when mouse over to the drop zone, change color */
}
.dropbox p {
  font-size: 1.2em;
  text-align: center;
  padding: 50px 0;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 75%;
  margin: 20px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
 
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
  text-align: center;
}
.modal-container .btn {
  margin: 0 auto;
}
.modal-header {
  margin-top: 0;
  color: #2c3e50;
  font-size: 30px;
}
.modal-body {
  margin: 20px 0;
  white-space: pre-line;
}
.modal-default-button {
  margin: 0 auto;
}
.meta-table{ 
    display: table; 
    margin-left:auto; 
    margin-right:auto;
}
.meta-cell{ 
    display: table-cell; }

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */
.modal-enter {
  opacity: 0;
}
.modal-leave-active {
  opacity: 0;
}
.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
.file-info {
  font-size: 12px;
  text-align: left;
}
.edit-add {
  color: #337ab7;
}
select:invalid { color: gray; }
</style>
